import { useCallback } from 'react';
import { useLocalStore } from 'mobx-react';
import { meeting as meetingModel } from '@/models';

export interface TitleChangeResp {
  newTitle: string;
}

export default function useTitleChange() {
  const meeting = useLocalStore(() => meetingModel);

  const titleChange = useCallback(
    (body: TitleChangeResp) => {
      const { newTitle } = body;
      meeting.setTitle(newTitle);
      document.title = newTitle;
    },
    [meeting]
  );

  return titleChange;
}
